import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { site } from '../../data/site';
import { buttonStyles, container } from '../../utils/styles';
export function CtaBand() {
  const {
    t
  } = useLanguage();
  return <section className="bg-brand py-20 text-white sm:py-24" aria-labelledby="cta-heading" data-id="element-368" data-mp="2nfskz0p5853k">
      <div className={`${container} mx-auto max-w-3xl text-center`} data-id="element-369" data-mp="28r4sx4eiadid">
        <h2 id="cta-heading" className="text-3xl font-bold leading-tight sm:text-5xl" data-id="element-370" data-mp="2djfv6dwpybe3">
          {t({
          en: 'Limited Spots Available — Act Now',
          es: 'Espacios Limitados — Actúa Ahora'
        })}
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-white/90 sm:text-xl" data-id="element-371" data-mp="24q2u2ooi43gx">
          {t({
          en: "Your first consultation is completely free — no pressure, no commitment. Just a warm, caring conversation about your loved one's needs.",
          es: 'Tu primera consulta es completamente gratuita — sin presión, sin compromiso. Solo una conversación cálida y atenta sobre las necesidades de tu ser querido.'
        })}
        </p>
        <div className="mt-10 flex flex-col justify-center gap-3 sm:flex-row" data-id="element-372" data-mp="ltrz7aaq3rr8">
          <Link to="/contact" className={`${buttonStyles.light} min-h-[56px] bg-gold px-8 text-lg text-brand-deeper hover:bg-[#C8955F]`} data-id="element-373" data-mp="zqx0yy3em4go">
            <CalendarIcon className="h-5 w-5" aria-hidden="true" data-id="element-374" data-mp="81bzaid4c9uj" />
            {t({
            en: 'Schedule Free Consultation',
            es: 'Agendar Consulta Gratuita'
          })}
          </Link>
          <a href={site.tel} className={`${buttonStyles.outlineLight} min-h-[56px] px-8 text-lg`} data-id="element-375" data-mp="gscc7cozjb67">
            <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-376" data-mp="c24a3g1n2msx" />
            {t({
            en: `Call ${site.phoneDisplay}`,
            es: `Llamar ${site.phoneDisplay}`
          })}
          </a>
        </div>
      </div>
    </section>;
}